import useLocalStorage from 'use-local-storage';

//localStorage keys

const CONTENT_TRANSFER_EXPERIMENTAL_FEATURE =
	'ContentTransferExperimentalFeature';
const CREATE_PROJECT_V3_FEATURE = 'CreateProjectV3Feature';

export function useFeatureToggles() {
	const [useDecoupledDeployments, setUseDecoupledDeployments] =
		useLocalStorage<boolean>(CREATE_PROJECT_V3_FEATURE, true);
	const [contentTransferExpFeat, setContentTransferExpFeature] =
		useLocalStorage<boolean>(CONTENT_TRANSFER_EXPERIMENTAL_FEATURE, false);
	return {
		useDecoupledDeployments,
		setUseDecoupledDeployments,
		contentTransferExpFeat,
		setContentTransferExpFeature,
	};
}
